/**
 * Digit key for a label-only choice list.
 * "0" is the first option from the top, "1" the next, and so on.
 * Returns null when the key is not a single digit or the index is past the list.
 */
export function optionIndexFromDigitKey(key: string, optionCount: number): number | null {
    if (!/^[0-9]$/.test(key)) return null;
    const index = Number(key);
    if (index >= optionCount) return null;
    return index;
}
